import { OptionalLink } from '@atlassian/mpac-ui';
import React from 'react';
const FallbackInstallationDocumentation = props => {
  const {
    documentationUrl,
    appName
  } = props;
  return (
    /*#__PURE__*/
    React.createElement(OptionalLink, {
      href: documentationUrl,
      external: true,
      title: "View documentation for '".concat(appName, "'")
    }, "See this app's documentation for more information.")
  );
};
export default FallbackInstallationDocumentation;